import { Component } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Subscription, take, finalize } from 'rxjs';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { AlertComponent } from 'src/app/modules/components/alert/alert.component';
import { AfericaoAmpliacaoService } from 'src/app/modules/services/afericao-ampliacao/afericao-ampliacao.service';

@Component({
  selector: 'app-detail-afericao-ampliacao',
  templateUrl: './detail-afericao-ampliacao.component.html',
  styleUrls: ['./detail-afericao-ampliacao.component.scss']
})
export class DetailAfericaoAmpliacaoComponent {
idAfericao: string = '';
  afericao: any;
  selectedTabDetalhes = 0;

  // Subscriptions
  subscriptions: Subscription[] = [];

  // Screen width
  screenWidth: number = window.innerWidth;

  // === TABELA: Documentos Assinados ===
  sortState = {
    sortProperty: 'protocoloContrato.numeroProtocolo',
    sortDirection: 'asc'
  };

  columnConfig = [
    { columnDef: 'protocolo', header: 'Protocolo', property: 'protocoloContrato.numeroProtocolo' },
    { columnDef: 'descricao', header: 'Descrição', property: 'comentario' },
    { columnDef: 'dataUltimaAssinatura', header: 'Data de assinatura', property: 'dataUltimaAssinatura', customTd: true },
    { columnDef: 'actions', header: 'Ações', custom: true }
  ];

  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [];
  pageIndex = 0;
  pageSize = 10;
  totalPages = 1;
  totalElements = 0;

  // === TABELA: Análise Aferição ===
  sortStateAnalise = {
    sortProperty: 'analiseAfericao.protocoloContrato.numeroProtocolo',
    sortDirection: 'asc'
  };

  columnConfigAnalise = [
    { columnDef: 'protocolo', header: 'Protocolo', property: 'analiseAfericao.protocoloContrato.numeroProtocolo' },
    { columnDef: 'tipo', header: 'Tipo', property: 'tipoAnalise.nome' },
    { columnDef: 'descricao', header: 'Descrição', property: 'descricao' },
    { columnDef: 'responsavel', header: 'Responsável', property: 'usuario.nome' },
    { columnDef: 'prazo', header: 'Prazo', property: 'prazo', customTd: true },
    { columnDef: 'statusAtual', header: 'Status', property: 'statusAtual', customTd: true },
    { columnDef: 'actions', header: 'Ações', custom: true }
  ];

  dataSourceAnalise = new MatTableDataSource<any>();
  displayedColumnsAnalise: string[] = [];
  pageIndexAnalise = 0;
  pageSizeAnalise = 10;
  totalPagesAnalise = 1;
  totalElementsAnalise = 0;
  screenWidthAnalise: number = window.innerWidth;

  // === TABELA: Documentos para Assinar ===
  sortStateAssinar = {
    sortProperty: 'documentoComprovacao.protocoloContrato.numeroProtocolo',
    sortDirection: 'asc'
  };

  columnConfigAssinar = [
    { columnDef: 'protocolo', header: 'Protocolo', property: 'documentoComprovacao.protocoloContrato.numeroProtocolo' },
    { columnDef: 'comentario', header: 'Descrição', property: 'documentoComprovacao.comentario' },
    { columnDef: 'assinante', header: 'Assinante', property: 'usuario.nome' },
    { columnDef: 'dataAssinatura', header: 'Data de Assinatura', property: 'dataAssinatura', customTd: true },
    { columnDef: 'actions', header: 'Ações', custom: true }
  ];

  dataSourceAssinar = new MatTableDataSource<any>();
  displayedColumnsAssinar: string[] = [];
  pageIndexAssinar = 0;
  pageSizeAssinar = 10;
  totalPagesAssinar = 1;
  totalElementsAssinar = 0;

  // === Filtros / Outros dados ===
  arrayStatus: any = [
    { label: "Todos", property: "" },
    { label: "Pendente de comprovação", property: "" },
    { label: "Comprovação enviada", property: "" },
    { label: "Em análise", property: "" },
    { label: "Parâmetro atestado", property: "" },
    { label: "Aguardando complementação das informações", property: "" },
  ];

  idDocumentoPendente: any;
  idUser: any;

  // === CONSTRUTOR ===
  constructor(
    private route: ActivatedRoute,
   private afericaoAmpliacaoService: AfericaoAmpliacaoService,
    private _snackBar: MatSnackBar,
    private loadingService: LoadingService,
    private router: Router,
    private pageSizeService: PageSizeService,
    public dialog: MatDialog,
    private toastService: ToastService,
    private modalCtrl: ModalController,
  ) {
      this.route.paramMap.subscribe((params: ParamMap) => {
      this.idAfericao = params.get('id') ?? '';
      this.getData(this.idAfericao);
    });
  }

  ngOnInit(): void {
    this.displayedColumns = this.columnConfig.map(col => col.columnDef);
    this.displayedColumnsAssinar = this.columnConfigAssinar.map(col => col.columnDef);
    this.displayedColumnsAnalise = this.columnConfigAnalise.map(col => col.columnDef);
  }

  // Expande os dados para exibir linha de detalhe na tabela
  getExpandedData(data: any[]): any[] {
    return data.flatMap(row => [row, { detailRow: true, ...row }]);
  }

  // Requisição da aferição inicial
  getData(idAfericao: string): void {
    this.afericaoAmpliacaoService
      .getAfericaoAmpliacao(idAfericao)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (res: any) => {
          this.afericao = res;
        },
        error: (erro: any) => this.handleRequestError(erro)
      });
  }

    private handleRequestError(erro: any): void {
      if (erro.status !== 500 && erro.status) {
        this.openSnackBar(erro.error.message, 'error');
      } else if (erro.error?.error === 'Unprocessable Entity') {
        this.openSnackBar(erro.error.message, 'warning');
      } else {
        this.openSnackBar(
          'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
          'error'
        );
      }
    }
  
  
    // === SNACKBAR DE ALERTA ===
    openSnackBar(description: string, type: string): void {
      const classMap: Record<string, string> = {
        sucess: 'snacbar-sucess',
        warning: 'snacbar-warning',
        error: 'snacbar-error'
      };
  
      const classSnack = classMap[type] || 'snacbar-default';
  
      this._snackBar.openFromComponent(AlertComponent, {
        duration: 3000,
        panelClass: [classSnack, 'snackbar-custom'],
        data: { description, type },
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
    }
   // === NAVEGAÇÃO ===
  close(): void {
    this.router.navigate(['acompanhamentos/servicos-ampliacao']);
  }
}
